//Menus defined for all pages thst contain menu
/*
 * permissions: ["full", "readonly", "user"]
 * It means that this icon would show on
 * full access login + readonly access login and on all auth states (user + smith + nbe)
 *
 * if i want to hide a icon entirely, just leave it empty
 * permissions: []
 */

export const Home = [
  {
    icon: "btnmail.png",
    label: "lng_service_mail",
    path: "/messages",
    permissions: ["full", "user"]
  },
  {
    icon: "notifikationer.png",
    label: "lng_mail",
    path: "/notification",
    permissions: ["full", "readonly", "user"]
  },

  {
    icon: "btn_boiler_rtb.png",
    label: "lng_boiler",
    path: "/boiler",
    permissions: ["full", "readonly", "user"]
  },
  {
    icon: "btn-9-hopper.png",
    label: "lng_hopper",
    path: "/hopper",
    permissions: ["full", "readonly", "user"]
  },
  {
    icon: "btn-4-hwt.png",
    label: "lng_dhw",
    path: "/dhw",
    permissions: ["full", "readonly", "user"]
  },
  {
    icon: "btn-6-weather.png",
    label: "lng_weather",
    path: "/weather",
    permissions: ["full", "readonly", "user"]
  },
  {
    icon: "button_solar_heat.png",
    label: "lng_solar",
    path: "/sun",
    permissions: ["full", "readonly", "user"]
  },
  {
    icon: "button-ext-energy.png",
    label: "lng_ext_energy",
    path: "/ext-energy",
    permissions: ["full", "readonly", "user"]
  },
  {
    icon: "cascade-btn-barchart.png",
    label: "lng_consumption",
    path: "/consumption",
    permissions: ["full", "readonly", "user"]
  },
  {
    icon: "cascade-btn-chart.png",
    label: "lng_charts",
    path: "/charts",
    permissions: ["full", "readonly", "user"]
  },
  {
    icon: "btn-16-log.png",
    label: "lng_eventlog",
    path: "/events",
    permissions: ["full", "readonly", "user"]
  },
  {
    icon: "btn-17-system.png",
    label: "lng_setup",
    path: "/system",
    permissions: ["full", "readonly", "user"]
  }
];

export const Boiler = [
  {
    icon: "button_o2.png",
    label: "lng_oxygen",
    path: "/boiler/o2",
    permissions: ["full", "readonly", "user"]
  },
  {
    icon: "button_cleaning.png",
    label: "lng_cleaning",
    path: "/boiler/cleaning",
    permissions: ["full", "readonly", "user"]
  },
  {
    icon: "button_regulation.png",
    label: "lng_regulation",
    path: "/boiler/regulation",
    permissions: ["full", "readonly", "smith"]
  },
  {
    icon: "button_fan.png",
    label: "lng_fan",
    path: "/boiler/fan",
    permissions: ["full", "readonly", "smith"]
  },
  {
    icon: "button_ignition.png",
    label: "lng_igniter",
    path: "/boiler/igniter",
    permissions: ["full", "readonly", "user"]
  },
  {
    icon: "button_pump.png",
    label: "lng_pump",
    path: "/boiler/pump",
    permissions: ["full", "readonly", "user"]
  }
];

export const Hopper = [
  {
    icon: "button_ext_feed.png",
    label: "lng_ext_feed",
    path: "/hopper/extfeed",
    permissions: ["full", "readonly", "user"]
  }
];

export const System = [
  {
    icon: "btn-11-screen.png",
    label: "lng_screen",
    path: "/system/screen",
    permissions: ["full", "readonly", "user"]
  },
  {
    icon: "btnadvanced.png",
    label: "lng_advanced",
    path: "/system/advanced",
    permissions: [] // Not visible so far, set to full, readonly and user
  },
  {
    icon: "user-icon.png",
    label: "lng_register",
    path: "/register",
    permissions: ["full", "user"]
  },
  {
    icon: "user-icon.png",
    label: "lng_user_title",
    path: "/system/settings",
    permissions: ["full", "user"]
  },
  {
    icon: "btn-20-backup.png",
    label: "lng_backup",
    path: "/system/backup",
    permissions: ["full", "user"]
  },
  // {
  //   icon: "payment.png",
  //   label: "lng_payment_invoices_tp",
  //   path: "/system/payment-administration",
  //   permissions: ["full", "user"]
  // }
];

export const UserAcc = [
  {
    icon: "payment.png",
    label: "lng_payment_invoices_tp",
    path: "/system/settings/payment",
    permissions: ["full", "user"]
  }
];
